export const ERROR_MESSAGES = {
    CREATE_SESSION: 'Oops! Something went wrong. Please come back later.',
    LOGIN: 'Oops! Error logging in. Please try again later.',
    LOGOUT: 'Oops! Something went wrong. Please try again later.',
    SESSION_TIME_OUT: 'Session timed out. Please login.',
    FORGOT_PASSWORD: 'Oops! Something went wrong. Please try again later.',
    RESET_PASSWORD: 'Oops! Something went wrong. Please try again later.',
    MARK_USER_ACTIVE: 'Oops! Something went wrong. Please try again later.',
    ONLY_CSV_FILE: 'Oops ! Only CSV files are allowed for upload.',
    FALLBACK_ERROR: 'Oops! Something went wrong. Please try again later.',
    PLEASE_ENTER_EMAIL_ID: 'Please Enter Atleast one emailId',
    ONLY_IMAGE_FILE: 'Oops! Only Image files are allowed for upload.',
    ONLY_CSV_XLSM_XLSX_FILE: 'Oops! Only CSV, XLSX, and XLSM files are allowed for upload.',
    PLEASE_SELECT_BIN_TYPE: 'Please select the bin type.',
    PLEASE_UPLOAD_BIN_FILE: 'Please upload the bin file.',
    OFFLINE_MSG: 'Oops! You are offline. Please reload.'
};

export const SUCCESS_MESSAGES = {
    LOGIN_SUCCESS_WELCOME: name => `Welcome back ${name}!`,
    LOGOUT_SUCCESS: 'Successfully logged out.',
    FORGOT_PASSWORD: 'A reset link has been sent to your mail.',
    RESET_PASSWORD: 'Password has been reset successfully.',
    SET_PASSWORD: 'Password has been set successfully.',
    CREATE_ROLE: 'Role created successfully.',
    UPDATE_ROLE: 'Role updated successfully.',
    OTP: 'Otp successfully sent',
    CREATE_ENTITY: name => `${name} successfully created`,
    SAVE_DATA: name => `${name} data successfully saved`,
    UPDATE_DATA: name => `${name} data successfully updated`,
    SHARED_DATA: name => `${name} successfully shared`,
    REMOVED_DATA: name => `${name} data successfully removed`,
    ADD_DATA: name => `${name} data successfully added.`,
    REFUND: name => `${name} amount successfully initiated`,
    IMAGE: name => `${name} successfully updated.`,
    APPLICATION_UPDATED_SUCCESSFULLY: 'Application updated successfully',
    UPDATE_MAKER_REQUEST_SUCCESS: name =>
        `${name} update request added successfully`,
    MANDATE_STATUS_UPDATE_SUCCESS: 'Mandate status updated successfully!',
    MLE_SUCCESS: 'MLE form has been submitted successfully!',
    MLE_UPDATED: 'MLE form has been updated successfully!',
    BUSINESS_SECTION_SUCCESS: 'Business details updated successfully!',
    UBO_SECTION_SUCCESS: 'UBO details updated successfully!',
};

export const VERIFICATION_MESSAGE = {
    USER_APPROVED: name => `${name} Approved.`,
    USER_REJECTED: name => `${name} REJECTED.`,
    STATUS_UPDATE: 'User status updated.',
    ROLE_STATUS_UPDATE: 'Role status updated.',
};

export const USER_MANAGEMENT_MSG = {
    USER_UPDATE: 'User updated',
    USER_CREATE: 'User created',
};

export const MERCHANT_ADJUSTMENT_MSG = {
    MERCHANT_ADJUSTMENT_CREATE: 'Merchant adjustment created',
};
